module.exports = __webpack_public_path__ + "img/logo8.cb322d4a.jpg";